import { render, staticRenderFns } from "./CreateOtherReceiptPayment.vue?vue&type=template&id=525da57a"
import script from "./CreateOtherReceiptPayment.vue?vue&type=script&lang=js"
export * from "./CreateOtherReceiptPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports